import React, { useEffect, useRef } from "react";

const Popover = ({ isVisible, position, content, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    if (isVisible && popoverRef.current) {
      const { top, left, width } = position;
      popoverRef.current.style.top = `${top - 110}px`;
      popoverRef.current.style.left = `${left + width / 2}px`;
    }
  }, [isVisible, position]);

  if (!isVisible) return null;

  return (
    <div ref={popoverRef} className="popover">
      <button className="close-btn" onClick={onClose}></button>
      <div id="popover-content" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default Popover;